/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PreCheckResultCode {
    NO_REFERRALS = 'NoReferrals',
    NOT_PUBLISHED = 'NotPublished',
    ALREADY_REGISTERED = 'AlreadyRegistered',
    CLOSED = 'Closed',
    WAITLIST = 'Waitlist',
    BLOCKED = 'Blocked',
}
